import { Link } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import logo from "../assets/logo.png";

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const navLinks = useMemo(
    () => [
      { label: "Home", to: "/" },
      { label: "Packages", to: "/packages" },
      { label: "About Us", to: "/about" },
      // { label: "Blog", to: "/blog" },
      // { label: "Rooms & Taxi", to: "/rooms" },
      { label: "Taxi", to: "/taxi" },
      { label: "Gallery", to: "/gallery" },
      { label: "Contact", to: "/contact" },
      { label: "Track Booking", to: "/booking-status" },
    ],
    []
  );

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 12);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileMenuOpen]);

  const toggleMobileMenu = () => setMobileMenuOpen((prev) => !prev);
  const handleLinkClick = () => setMobileMenuOpen(false);

  return (
    <header className={`ui-mdc-navbar ${scrolled ? "ui-mdc-navbar--scrolled" : ""}`}>
      <div className="ui-mdc-navbar-container">
        <div className="ui-mdc-navbar-brand">
          <Link to="/" className="ui-mdc-navbar-brand-link" onClick={handleLinkClick}>
            <img className="ui-mdc-navbar-logo" src={logo} alt="Yala Vibe" />
            <span className="ui-mdc-navbar-brand-text">Yala Vibe</span>
          </Link>
        </div>

        <nav className="ui-mdc-navbar-nav" aria-label="Primary navigation">
          {navLinks.map(({ label, to }) => (
            <Link key={to} to={to} className="ui-mdc-navbar-link">
              {label}
            </Link>
            
          ))}
          
        </nav>

        <div className="ui-mdc-navbar-actions">
          <Link
            to="/packages"
            className="ui-mdc-navbar-button"
          >
            Book Now
          </Link>

          <button
            type="button"
            className="ui-mdc-navbar-toggle"
            onClick={toggleMobileMenu}
            aria-expanded={mobileMenuOpen}
            aria-controls="ui-mdc-mobile-nav"
            aria-label={mobileMenuOpen ? "Close primary navigation" : "Open primary navigation"}
          >
            {mobileMenuOpen ? (
              <svg
                className="ui-mdc-navbar-toggle-icon"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg
                className="ui-mdc-navbar-toggle-icon"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      <div
        id="ui-mdc-mobile-nav"
        className={`ui-mdc-navbar-mobile ${mobileMenuOpen ? "ui-mdc-navbar-mobile--open" : ""}`}
      >
        <div className="ui-mdc-navbar-mobile-content">
          {navLinks.map(({ label, to }) => (
            <Link key={to} to={to} className="ui-mdc-navbar-mobile-link" onClick={handleLinkClick}>
              {label}
            </Link>
          ))}
          <Link
            to="/booking"
            className="ui-mdc-navbar-mobile-button"
            onClick={handleLinkClick}
          >
            Book Now
          </Link>
        </div>
      </div>
    </header>
  );
}
